<template>
  <div class="fb fb-col fb-cross-center fb-main-center pb-72 face">
    <span class="font-28 c-111F2C-40">{{ userInfo.face ? '已录入' : '' }}</span>
    <div class="pt-32 w-100 h-100 fb fb-cross-center fb-main-center">
      <i class="iconfont font-200 c-006AFE">&#xe67b;</i>
    </div>
    <div class="pt-20 c-27C98D font-28"
      ><i class="iconfont font-34 c-27C98D pr-4">&#xe764;</i>隐私保障中</div
    >
    <span class="pt-34 font-34 c-171A1D">{{
      filterName(dingUserName, 4)
    }}</span>
    <div class="footer fb fb-col fb-main-end fb-cross-center" v-if="curIsAdmin">
      <md-button class="mb-16" @click="handleModify">修改人脸</md-button>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import { faceUrl, filterName } from '@/utils/comUtils'
export default {
  name: 'PageMyface',
  mixins: [mixin],
  components: {},
  props: {},
  data() {
    return {
      userInfo: {}
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getApi('getFaceUserInfo', { memberId: this.orgUserId }, true).then(
      res => {
        this.userInfo = res
      }
    )
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    filterName,
    handleModify() {
      const url = faceUrl(this.orgId, this.orgUserId, this.orgUserId)
      // mcOpenLink({ url: url })
      // window.location.href = url
      this.mixinRouter('/faceInput/faceFrame', { url })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-27C98D {
  color: #27c98d;
}
</style>
